// extracted by mini-css-extract-plugin
export default {"term-pill":"styles__term-pill--8PABo","term-card":"styles__term-card--AVbXm","expanded":"styles__expanded--8+Clp"};